// extracted by mini-css-extract-plugin
export default {"requiredVendorsSection":"requiredVendorsSection__NDk3Z","vendorCard":"vendorCard__YjFkY"};